// Mostra o texto da IA com a formatação simples que ela usa: **negrito** e
// listas com "- " ou "* ". Monta elementos React (nunca HTML cru), então
// nada que venha do modelo é interpretado como código.
function inline(text, keyPrefix) {
  return text.split(/(\*\*[^*]+\*\*)/g).filter(Boolean).map((part, index) =>
    part.startsWith("**") && part.endsWith("**") && part.length > 4
      ? <strong key={`${keyPrefix}-${index}`} className="font-semibold">{part.slice(2, -2)}</strong>
      : <span key={`${keyPrefix}-${index}`}>{part}</span>
  );
}

export function AIText({ text }) {
  const blocks = [];
  let list = null;
  (text || "").split("\n").forEach((rawLine, index) => {
    const line = rawLine.trimEnd();
    const bullet = line.match(/^\s*[-*•]\s+(.*)$/);
    if (bullet) {
      if (!list) { list = []; blocks.push({ type: "list", items: list, key: `l${index}` }); }
      list.push({ text: bullet[1], key: `i${index}` });
      return;
    }
    list = null;
    blocks.push(line.trim() ? { type: "p", text: line, key: `p${index}` } : { type: "gap", key: `g${index}` });
  });
  return (
    <div className="space-y-1" data-testid="ai-text">
      {blocks.map((block) => {
        if (block.type === "list") {
          return (
            <ul key={block.key} className="list-disc space-y-1 pl-5">
              {block.items.map((item) => <li key={item.key}>{inline(item.text, item.key)}</li>)}
            </ul>
          );
        }
        if (block.type === "gap") return <div key={block.key} className="h-1" />;
        return <p key={block.key}>{inline(block.text, block.key)}</p>;
      })}
    </div>
  );
}
